import { createSelector } from '@ngrx/store';

import * as userActivitiesReducer from '../reducers/user-activities.reducer';
import { getUserActivitiesState } from '../../state.reducer';

export const isUpdatingQuitDate = createSelector(
  getUserActivitiesState,
  userActivitiesReducer.userQuitDateUpdating
);
